/** Desktop cart drawer width — keep in sync with body push in MarketplaceCartContext. */
export const MARKETPLACE_CART_PANEL_WIDTH_PX = 320
